import { flow } from 'lodash';

import { NAME } from './profile.constant';

import { selectModulesState } from '@giro-app/store/modules/modules.selector';

const selectState = (state) => state[NAME];

export const selectProfileState = flow(selectModulesState, selectState);
